import React, { useEffect } from 'react'
// components
import LoginForm from './LoginForm'
// others
import { GAPageView, initGA } from '../../index'

// component
function Login() {
    // Google analytics
    useEffect(() => {
        initGA()
        GAPageView()
    }, [])

    // template
    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--body-bg)',
            padding: '1rem'
        }}>
            <LoginForm />
        </div>
    )
}

export default Login
